// extracted by mini-css-extract-plugin
export default {"lastUpdated":"lastUpdated---PYEjA","lastUpdatedUser":"lastUpdatedUser---mg3yC"};